export type Theme = {
  mode: ThemeMode;
  color: string;
};

const DARK_THEME: Theme = {
  mode: "dark",
  color: "white",
};

const LIGHT_THEME: Theme = {
  mode: "light",
  color: "black",
};

export const THEME = {
  dark: DARK_THEME,
  light: LIGHT_THEME,
};

export type ThemeMode = keyof typeof THEME;

export const getNewTheme = (mode: string): Theme => {
  const newMode = mode === "light" ? "dark" : "light";
  return THEME[newMode];
};
export const getNewMode = (mode: string): ThemeMode => {
  return mode === "light" ? "dark" : "light";
};
export const getCurrentTheme = (mode: string): Theme => {
  return THEME[mode === "light" ? "light" : "dark"];
};
